import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const PageCard = ({ page }) => {
  return (
    <div className="w-full relative px-[10px] box-border block">
      <Link
        to={page.buttonLink}
        className="relative block no-underline rounded-[10px] overflow-hidden cursor-pointer"
      >
        <div className="relative block pb-[70%] overflow-hidden">
          {page.backgroundImage?.gatsbyImageData && (
            <div className="absolute block max-w-full top-0 left-0 w-full h-full align-middle">
              <GatsbyImage
                image={page.backgroundImage.gatsbyImageData}
                alt={page.backgroundImage.title}
                className="relative block w-full h-full align-bottom object-cover object-center"
                objectFit="cover"
                objectPosition="center"
                loading="lazy"
              />
            </div>
          )}
        </div>
        <div
          className="absolute top-0 left-0 flex w-full h-full flex-col items-center justify-center text-center px-5 md:px-10 bg-black/30 group"
          role="group"
        >
          <h2 className="text-xl md:text-3xl leading-[30px] md:leading-[45px] tracking-wide transition-transform duration-[400ms] text-white font-bold">
            {page.title}
          </h2>
        </div>
        <div className="absolute bottom-4 md:bottom-10 left-4 md:left-10">
          <button
            className="bg-transparent text-white px-5 py-[6px] text-[15px] rounded-full border-2 border-solid border-white cursor-pointer tracking-wider no-underline
            hover:scale-110 transition-transform duration-[400ms]"
          >
            {page.buttonText}
          </button>
        </div>
      </Link>
    </div>
  );
};

export default PageCard;
